export default {
      id: "chevron-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#chevron",
      toString: function () {
        return this.url;
      }
    }